import { useTranslation } from 'react-i18next';
import BrandLogo from '@/components/feature/BrandLogo';

export default function BrandPanel() {
  const { t } = useTranslation();

  const points = [
    { icon: 'ri-map-pin-user-line', label: t('login.trust1') },
    { icon: 'ri-fingerprint-line', label: t('login.trust2') },
    { icon: 'ri-file-list-3-line', label: t('login.trust3') },
  ];

  return (
    <div className="relative hidden overflow-hidden lg:block">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20modern%20lottery%20themed%20abstract%20background%20with%20glossy%20numbered%20loto%20balls%20floating%20above%20flowing%20deep%20emerald%20and%20warm%20gold%20organic%20shapes%2C%20dramatic%20soft%20lighting%2C%20premium%20editorial%20fintech%20aesthetic%2C%20subtle%20depth%20and%20grain%2C%20no%20text%2C%20elegant%20trustworthy%20atmosphere%2C%20rich%20dark%20tones%20for%20strong%20text%20contrast%2C%20high%20detail&width=1000&height=1400&seq=izipay-auth-panel-01&orientation=portrait&nocache=true"
          alt="PayLOTO"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-primary-950/85"></div>

      <div className="relative z-10 flex h-full w-full flex-col justify-between p-10 xl:p-14">
        <div className="flex items-center gap-3">
          <BrandLogo className="h-12" onDark />
        </div>

        <div className="animate-fade-rise">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <i className="ri-global-line text-sm"></i>
            {t('brand.tagline')}
          </span>
          <h2 className="mt-5 max-w-md font-heading text-4xl font-semibold leading-tight text-background-50">
            {t('login.trustTitle')}
          </h2>
          <ul className="mt-8 space-y-4">
            {points.map((point) => (
              <li key={point.icon} className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-background-50 backdrop-blur">
                  <i className={`${point.icon} text-base`}></i>
                </span>
                <span className="text-sm font-medium text-background-50/95">{point.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}